import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'


export type IRmaProductDTO = {
  product_id: number
  product_code: string
  product_name: string
  // delivered-product search omits oem entirely; keep it optional
  oem?: string | null
  ean?: string | null
  quantity: number
  image_url: string
  rma_allowed: boolean
  originMove?: number | null
  shipped_quantity?: number
  shipment_date?: string | null
  shipment_reference?: string | null
  sale_reference?: string | null
  shipmentID?: string | null
  saleID?: string | null
  erp_order_number?: string | null
  sale_date?: string | null
  product_external?: string | null
  sale_line_origin?: number | null
}


export class RmaProductDTO {
  productId: number
  productCode: string
  productName: string
  oem: string | null
  ean: string | null
  quantity: number
  imageUrl: string
  rmaAllowed: boolean
  originMove: number | null
  shippedQuantity: number
  shipmentDate: string | null
  shipmentReference: string | null
  saleReference: string | null
  shipmentId: string | null
  saleId: string | null
  erpOrderNumber: string | null
  saleDate: string | null
  productExternal: string | null
  saleLineOrigin: number | null

  constructor(data: IRmaProductDTO) {
    this.productId = data.product_id
    this.productCode = data.product_code
    this.productName = data.product_name
    this.oem = data.oem ?? null
    this.ean = data.ean ?? null
    this.quantity = data.quantity
    this.imageUrl = data.image_url
    this.rmaAllowed = data.rma_allowed
    this.originMove = data.originMove ?? null
    this.shippedQuantity = data.shipped_quantity ?? 0
    this.shipmentDate = data.shipment_date ?? null
    this.shipmentReference = data.shipment_reference ?? null
    this.saleReference = data.sale_reference ?? null
    this.shipmentId = data.shipmentID ?? null
    this.saleId = data.saleID ?? null
    this.erpOrderNumber = data.erp_order_number ?? null
    this.saleDate = data.sale_date ?? null
    this.productExternal = data.product_external ?? null
    this.saleLineOrigin = data.sale_line_origin ?? null
  }
}


const validate = createValidate<IRmaProductDTO>()

export const parseRmaProductDTO = (data: unknown): RmaProductDTO => {
  validateGuard(validate, data, 'rma product')
  return new RmaProductDTO(data)
}


const validateList = createValidate<IRmaProductDTO[]>()

export const parseRmaProductDTOList = (data: unknown): RmaProductDTO[] => {
  validateGuard(validateList, data, 'rma products')
  return (data as IRmaProductDTO[]).map(parseRmaProductDTO)
}
